import { Avatar } from '@material-ui/core'
import React from 'react'
import CloseIcon from '@material-ui/icons/Close';

function index({name, uid, profilePhotoUrl, fullDetails, allUsersInDatabase, setAllUsersInDatabase, newSelectedMembers, setNewSelectedMembers}) {
  const handleClick = () => {
    let remainingMembers = newSelectedMembers.filter(member => member.uid !== uid);
    setAllUsersInDatabase([...allUsersInDatabase, fullDetails])
    setNewSelectedMembers(remainingMembers)
  }

  return (
    <div className="single__added__contact">
      <Avatar className="single__added__avatar" src={profilePhotoUrl} />
      <p>{name}</p>
      <CloseIcon onClick={handleClick} />
    </div>
  )
}

export default index
